<template>
  <div class="OutsourcingList">
    <HearderTitle name="外线员工" />
    <div class="tableBox">
      <div class="tool_bar">
        <el-form :inline="true" :model="queryInfo">
          <el-form-item>
            <el-input v-model="queryInfo.pername" placeholder="姓名/手机号"></el-input>
          </el-form-item>
          <el-form-item style="margin-left: -10px">
            <el-button class="lightBlueBtn searchBtn" type="primary" size="small" @click="search()">查询</el-button>
          </el-form-item>
          <el-form-item style="margin-right: 0; float: right">
            <el-button class="lightBlueBtn searchBtn" type="primary" size="small" @click="$router.push({ name: 'addOutsourcing' })">添加外线</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <el-table ref="refTable" header-cell-class-name="h_bg" :data="tableData" style="width: 100%">
          <el-table-column prop="pername" label="姓名" width="70" align="center"> </el-table-column>
          <el-table-column prop="dep_id" label="部门" align="center"> </el-table-column>
          <el-table-column prop="roles" label="岗位" align="center"> </el-table-column>
          <el-table-column prop="sex" label="性别" align="center"> </el-table-column>
          <el-table-column prop="province" label="籍贯" align="center"> </el-table-column>
          <el-table-column prop="birthday" label="生日" align="center"> </el-table-column>
          <el-table-column label="年龄" align="center">
            <template slot-scope="scope">
              <div>
                {{ scope.row.birthday | getAge }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="contact" width="158" label="手机号" align="center"> </el-table-column>
          <el-table-column prop="cardid" width="200" label="身份证号" align="center"> </el-table-column>
          <el-table-column prop="inday" label="入职日期" align="center"> </el-table-column>
          <el-table-column prop="prepactday" label="转员工" align="center">
            <template slot-scope="scope">
              <div style="cursor: pointer; color: #015293">
                <span class="select" @click="$router.push({ name: 'transferIn', params: { id: scope.row.id, index: scope.$index, type: 'outsourcing' } })">转入</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="158">
            <template slot-scope="scope">
              <div class="table_btns">
                <el-button size="mini" @click="$router.push({ name: 'outsourcingDetail', params: { id: scope.row.id } })">查看</el-button>
                <el-button @click="$router.push({ name: 'editOutsourcing', params: { id: scope.row.id, index: scope.$index } })" size="mini">编辑</el-button>
                <el-button size="mini" @click="del(scope.row.id)" class="warning">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination_box">
          <el-pagination @current-change="handleCurrentChange" :current-page="queryInfo.pageNum" :page-size="queryInfo.pageSize" layout="total, prev, pager, next,jumper" :total="total" background> </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getDepList } from '@/api/common.js'
  import { delOutsourcing, getOutsourcingList } from '@/api/personnelList'
  import HearderTitle from '@/components/HearderTitle'
  import pageCacheMix from '@/mixins/pageCacheMix'
  import { dateSubMonth, getAge } from '@/util'
  export default {
    name: 'outsourcingList',
    mixins: [pageCacheMix],
    data() {
      return {
        queryInfo: {
          // 姓名
          pername: '',
          // 当前页
          pageNum: 1,
          // 每页数量
          pageSize: 14,
        },
        tableData: [],
        total: 0,
        datalist: [],
      }
    },
    async created() {
      this.getOutsourcingList()
      let { data } = await getDepList()
      this.datalist = data
    },
    methods: {
      // 获取外线人员列表
      async getOutsourcingList() {
        let { plist } = await getOutsourcingList(this.queryInfo)
        this.tableData = plist.data
        this.total = plist.total
      },
      // 搜索
      search() {
        // 页码恢复第一页
        this.queryInfo.pageNum = 1
        this.getOutsourcingList()
      },
      edit(id) {},
      // 删除人员
      async del(id) {
        if (!id) return this.$message.error('请选择要删除的数据')
        const res = await this.$confirm('您确定删除该用户吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).catch((err) => err)
        if (res !== 'confirm') return this.$message.info('取消成功')
        let response = await delOutsourcing({ id })
        if (response.status !== 200) {
          this.$message.error('删除失败')
        } else {
          this.$message.success('删除成功')
          // 删除成功后刷新页面
          this.getOutsourcingList()
        }
      },
      // 监听当前页码的变化
      handleCurrentChange(newpagenum) {
        this.queryInfo.pageNum = newpagenum
        this.getOutsourcingList()
      },
    },
    components: { HearderTitle },
    filters: {
      // 计算年龄
      getAge(age) {
        return getAge(age)
      },
      // 计算入职时间
      dateSubMonth(date) {
        return dateSubMonth(date)
      },
    },
    // 局部更新编辑后数据
    activated() {
      let editData = sessionStorage.getItem('editOutsourcingData') || null
      let editDataIndex = sessionStorage.getItem('editDataIndex') || ''
      if (editData && editDataIndex !== '') {
        editData = JSON.parse(editData)
        // 更新修改数据
        this.$set(this.tableData, editDataIndex, editData)
        //删除缓存数据
        sessionStorage.removeItem('editDataIndex')
        sessionStorage.removeItem('editOutsourcingData')
      } else {
        //删除缓存数据
        sessionStorage.removeItem('editDataIndex')
        sessionStorage.removeItem('editOutsourcingData')
        return
      }
    },
  }
</script>

<style lang="less">
  .OutsourcingList {
    .tableBox {
      .tool_bar {
        padding-top: 28px;
        padding-bottom: 18px;
        font-size: 14px;
        color: #888;
        .el-form-item {
          margin-right: 20px;
          margin-bottom: 0;

          .el-input__inner,
          .el-date-editor.el-input {
            width: 120px;
            height: 32px;
          }
          &:first-of-type {
            .el-input__inner {
              width: 210px;
            }
          }
          .el-date-editor.el-input {
            width: 120px;
            .el-input__inner {
              width: 120px;
            }
          }
          .el-input__inner {
            padding-left: 10px;
          }
          .middle {
            padding: 0 10px;
          }
          .searchBtn {
            width: 82px;
          }
        }
      }
      .el-table {
        min-height: 675px;
        &::before {
          height: 0;
        }
      }
    }
  }
</style>
